exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-49910138]:root {\n  --default-padding: 60px 0px 0px 0px;\n}\n@media screen and (max-width: 768px) {\n[data-v-49910138]:root {\n    --default-padding: 30px 0px 0px 0px;\n}\n}\n.banner[data-v-49910138] {\n  height: 350px;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n}", ""]);

// exports
